import { LiveVideoFlight, VideoFlight } from "@nova/protobuf"
import { createListenerMiddleware, createSelector } from "@reduxjs/toolkit"
import EventEmitter from "events"
import {
    selectLiveVideoFlightById,
    selectVideoFlightById,
} from "features/entity-caching/flights/selectors"
import { RootState } from "integrations/redux"
import { memoize } from "nodash"

const selectFlight = memoize((flightId: string) =>
    createSelector(
        [selectLiveVideoFlightById(flightId), selectVideoFlightById(flightId)],
        (liveFlight, videoFlight) =>
            (liveFlight || videoFlight) as LiveVideoFlight | VideoFlight | undefined
    )
)

export const flightListenerEventEmitter = new EventEmitter()
export const flightListenerMiddleware = createListenerMiddleware<RootState>()

export function startListeningToFlightChanges({ flightId }: { flightId: string }) {
    return flightListenerMiddleware.startListening({
        predicate: (_, currentState, previousState) => {
            return selectFlight(flightId)(currentState) !== selectFlight(flightId)(previousState)
        },
        effect: async () => {
            flightListenerEventEmitter.emit(flightId)
        },
    })
}
